import { create } from 'zustand';
import authService from '../services/authService';
import organizationService from '../services/organizationService';
import userService from '../services/userService';

const useAuthStore = create((set, get) => ({
  user: null,
  organizations: [],
  currentOrganization: null,
  isAuthenticated: false,
  isLoading: true,

  initialize: async () => {
    const token = localStorage.getItem('accessToken');
    if (!token) {
      set({ isLoading: false, isAuthenticated: false });
      return;
    }

    try {
      const [{ data: orgs }, { data: userData }] = await Promise.all([
        organizationService.getMyOrganizations(),
        userService.getProfile(),
      ]);
      const normalizedOrgs = orgs.map((o) => ({
        ...o,
        roleName: o.roleName || o.role_name,
        permissions: o.permissions || [],
      }));
      const savedOrgId = localStorage.getItem('organizationId');
      const currentOrg = normalizedOrgs.find((o) => o.id === savedOrgId) || normalizedOrgs[0];

      if (currentOrg) {
        localStorage.setItem('organizationId', currentOrg.id);
      }

      set({
        user: userData,
        isAuthenticated: true,
        organizations: normalizedOrgs,
        currentOrganization: currentOrg,
        isLoading: false,
      });
    } catch {
      localStorage.removeItem('accessToken');
      localStorage.removeItem('organizationId');
      set({ isAuthenticated: false, isLoading: false });
    }
  },

  login: async (email, password) => {
    const { data } = await authService.login({ email, password });
    localStorage.setItem('accessToken', data.accessToken);

    const defaultOrg = data.organizations[0];
    if (defaultOrg) {
      localStorage.setItem('organizationId', defaultOrg.id);
    }

    set({
      user: data.user,
      organizations: data.organizations,
      currentOrganization: defaultOrg,
      isAuthenticated: true,
    });

    return data;
  },

  register: async (formData) => {
    const { data } = await authService.register(formData);
    localStorage.setItem('accessToken', data.accessToken);
    localStorage.setItem('organizationId', data.organization.id);

    set({
      user: data.user,
      organizations: [data.organization],
      currentOrganization: data.organization,
      isAuthenticated: true,
    });

    return data;
  },

  logout: async () => {
    try {
      await authService.logout();
    } catch {
      // Ignore logout errors
    }

    localStorage.removeItem('accessToken');
    localStorage.removeItem('organizationId');

    set({
      user: null,
      organizations: [],
      currentOrganization: null,
      isAuthenticated: false,
    });
  },

  setCurrentOrganization: (org) => {
    localStorage.setItem('organizationId', org.id);
    set({ currentOrganization: org });
  },
}));

export default useAuthStore;
